import React, { FC, ReactNode, useContext } from 'react';
import { getV3AssetPath } from 'utils/V3AssetPathContext';
import { V3AssetPathContext } from 'App';
import { WppSkeleton, WppTypography } from '@wppopen/components-library-react';
import GeoLoaderImg from 'assets/geoLoader.png';
import styled from 'styled-components';

export interface MainLoaderProps {
    isLoading?: boolean;
    height?: number;
    children: ReactNode;
    header: string;
    text: string;
    withInnerContainer: boolean;
}

export const LoaderWrapper = styled.div`
    width: 100%;
    height: 100%;
`;

export const SkeletonWrapper = styled.div`
    position: relative;
`;

export const SkeletonSection = styled.div`
    display: grid;
    grid-template-columns: 192px auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 498px;
    height: 164px;
    border-radius: 6px;
    box-shadow: var(--wpp-box-shadow);
    background-color: white;
    padding: 16px 32px 16px 16px;
    column-gap: 16px;
`;

export const SkeletonImage = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 190px;
    height: 132px;
    border-radius: 6px;
    background-color: rgba(248, 249, 251, 1);
`;

export const SkeletonContent = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 8px;
    padding: 0 24px;
`;

export const MainLoader: FC<MainLoaderProps> = ({
    children,
    isLoading,
    height = 520,
    header = 'header',
    text = 'text',
    withInnerContainer,
}) => {
    const { isV3, assetPath } = useContext(V3AssetPathContext);
    return (
        <LoaderWrapper>
            {isLoading ? (
                <SkeletonWrapper>
                    <WppSkeleton
                        animation={true}
                        variant="rectangle"
                        width="100%"
                        height={height}
                    />
                    {withInnerContainer && (
                        <SkeletonSection>
                            <SkeletonImage>
                                <img
                                    src={getV3AssetPath(GeoLoaderImg, isV3, assetPath)}
                                    alt="img"
                                    width={150}
                                    height={92}
                                />
                            </SkeletonImage>
                            <SkeletonContent>
                                <div>
                                    <WppTypography type="xl-heading">{header}</WppTypography>
                                    <WppTypography type="s-body">{text}</WppTypography>
                                </div>
                            </SkeletonContent>
                        </SkeletonSection>
                    )}
                </SkeletonWrapper>
            ) : (
                children
            )}
        </LoaderWrapper>
    );
};
